import jisrLogo from 'assets/images/JisrLogo.svg'
import jisrComponyLogo from 'assets/images/jisr-logo.svg'
import JisrIcon from 'assets/figma-icons/version-2/jisr-new.svg'
import solutionsLogo from 'assets/images/makenhr-logo-new.png'
import ahadLogo from 'assets/images/ahad-logo.png'
import JsirNavLogo from 'assets/images/jisr.svg'
import MakenLogo from 'assets/images/makenLogo.svg'
import i18n from 'translations/i18n'
import { isRtl } from './uiHelpers'

const { PUBLIC_URL, REACT_APP_WHITE_LABEL = 'jisr' } = import.meta.env

const initLabels = {
  jisr: {
    name: 'Jisr',
    logo: jisrLogo,
    translation_name: isRtl ? 'جسر' : 'Jisr',
    translation_app_name: isRtl ? 'جسر' : 'Jisr HR',
    domain_url: 'jisr.net',
    favicon: `${PUBLIC_URL}/${REACT_APP_WHITE_LABEL}/favicon.ico`,
    componyLogo: jisrComponyLogo,
    extraLogo: JisrIcon,
    navLogo: JsirNavLogo,
  },
  maken: {
    name: 'Maken',
    logo: solutionsLogo,
    translation_name: isRtl ? 'مكّن' : 'Maken',
    translation_app_name: isRtl ? 'مكّن' : 'Maken HR',
    domain_url: 'makenhr.com',
    favicon: `${PUBLIC_URL}/${REACT_APP_WHITE_LABEL}/favicon.ico`,
    componyLogo: `${PUBLIC_URL}/${REACT_APP_WHITE_LABEL}/favicon.ico`,
    extraLogo: solutionsLogo,
    navLogo: MakenLogo,
  },
  ahad: {
    name: 'Ahad',
    logo: ahadLogo,
    translation_name: i18n.t('ahad'),
    translation_app_name: i18n.t('ahad_HR'),
    domain_url: 'jisr.net',
    favicon: `${PUBLIC_URL}/${REACT_APP_WHITE_LABEL}/favicon.ico`,
    componyLogo: '',
    extraLogo: ahadLogo,
  },
}

const labels = initLabels[REACT_APP_WHITE_LABEL]

export { labels }
